export const yodaMessageCostants = {
  GET_MESSAGE_REQUEST: "YODAMESSAGE_GET_MESSAGE_REQUEST",
  GET_MESSAGE_SUCCESS: "YODAMESSAGE_GET_MESSAGE_SUCCESS",
  GET_MESSAGE_REQUEST_FAILURE: "YODAMESSAGE_GET_MESSSAGE_REQUEST_FAILURE",
  CLEAR_MESSAGE_REQUEST: "YODAMESSAGE_CLEAR_MESSAGE_REQUEST",
  CLEAR_MESSAGE_REQUEST_FAILURE: "YODAMESSAGE_CLEAR_MESSAGE_REQUEST_FAILURE",
  CLEAR_MESSAGE_REQUEST_SUCCESS: "YODAMESSAGE_CLEAR_MESSAGE_REQUEST_SUCCESS",
};
